<div class="emds">
  <div class="modal-default modal-flex">
    <div class="modal-body">
      <ap-terminology-search
        class="flex-auto"
        [sessionRequest]="sessionRequest"
        (sessionTokenChange)="currentSessionToken = $event"
      ></ap-terminology-search>
    </div>
    <div class="modal-footer">
      <button
        id="terminology-search-modal-cancel"
        class="btn btn-secondary flex-pull-right btn-flush-right"
        (click)="apUserCancel()"
        translate
      >Cancel</button>
      <button
        id="terminology-search-modal-save"
        class="btn btn-primary flex-pull-right"
        (click)="tryClose()"
        translate
        [disabled]="this.sessionRequest.IsSingleSelect && ((codeSelected$ | async) === false)"
      >Save <ap-spinner *ngIf="tryClose.inProgress" size="1"></ap-spinner></button>
    </div>
  </div>
</div>
